import { loadState, saveState, persistFilters } from 'utils';
import {
  FETCH_GAMES,
  SET_ACTIVE_FILTER,
  SET_SELECTED_GAME,
  SET_FAVORITE_GAMES,
  SET_SELECTED_GAME_ID,
  SET_GAMES_RTP_WITH_ID,
  FETCH_GAMES_CATEGORIES,
  SET_CATEGORIES_LOADING_STATUS,
  SET_CASINO_GAMES_LOADING_STATUS,
} from 'store/actions/actionTypes';
import { LOADED } from 'constants/data';
import { gameFilters } from 'constants/games';

const { ALL_GAMES, FAVORITES } = gameFilters;

const favoriteGames = loadState(FAVORITES) || [];

const defaultState = {
  [FAVORITES]: {
    data: favoriteGames,
    loadingStatus: LOADED,
  },
  activeFilter: loadState('activeFilter') || ALL_GAMES,
  selectedGame: {},
  categories: [],
};

function gamesReducer(state = defaultState, action) {
  switch (action.type) {
    case FETCH_GAMES: {
      const { games, category, ...rest } = action.payload;

      return {
        ...state,
        [category]: {
          ...rest,
          data: state[category].data ? state[category].data.concat(games) : games,
        },
      };
    }
    case SET_FAVORITE_GAMES: {
      const persistedFavoriteGames = persistFilters(
        state[FAVORITES].data,
        action.payload,
        [FAVORITES],
        item => item.externalGameId === action.payload.externalGameId,
      );
      return {
        ...state,
        [FAVORITES]: {
          data: persistedFavoriteGames,
          loadingStatus: LOADED,
        },
        counts: {
          ...state.counts,
          [FAVORITES]: persistedFavoriteGames.length,
        },
      };
    }
    case SET_CASINO_GAMES_LOADING_STATUS: {
      const { category, status } = action.payload;

      return {
        ...state,
        [category]: {
          ...state[category],
          loadingStatus: status,
        },
      };
    }
    case SET_CATEGORIES_LOADING_STATUS: {
      return {
        ...state,
        categoriesLoadingStatus: action.payload,
      };
    }
    case FETCH_GAMES_CATEGORIES: {
      return {
        ...state,
        categories: action.payload,
      };
    }
    case SET_ACTIVE_FILTER: {
      saveState('activeFilter', action.payload);

      return {
        ...state,
        activeFilter: action.payload,
      };
    }
    case SET_SELECTED_GAME_ID: {
      return {
        ...state,
        selectedGameId: action.payload,
      };
    }
    case SET_SELECTED_GAME: {
      return {
        ...state,
        selectedGame: action.payload,
      };
    }
    case SET_GAMES_RTP_WITH_ID: {
      return {
        ...state,
        gamesRTPWithID: action.payload,
      };
    }
    default:
      return state;
  }
}

export default gamesReducer;
